const fadeFilter = () => {
  $("#filters_wrapper").addClass("faded_div");
};

const showFilter = () => {
  $("#filters_wrapper").removeClass("faded_div");
};

const fadeResult = () => {
  $("#results_wrapper").addClass("faded_div");
};

const showResult = () => {
  $("#results_wrapper").removeClass("faded_div");
};

const loadCategory = () => {
  $("#category-loading").fadeTo("fast", 0.5);
};

const showCategory = () => {
  $("#category-loading").fadeTo("fast", 0);
};

const loadResultsData = ({ resultsData }) => {
  $("#results_wrapper").html(resultsData);
};

const toggleMobileFilter = (opened) => {
  if (opened) {
    $(".filter-container")
      .removeClass("closedMobileFilter")
      .addClass("openMobileFilter");
  } else {
    $(".filter-container")
      .removeClass("openMobileFilter")
      .addClass("closedMobileFilter");
  }
};

const turnOnDesktopFilter = () => {
  $(".filter-container")
    .removeClass("openMobileFilter")
    .removeClass("closedMobileFilter")
    .addClass("desktopFilter");
};

const turnOffDesktopFilter = () => {
  $(".filter-container")
    .removeClass("filterExpanded")
    .removeClass("filterReduced")
    .removeClass("desktopFilter")
    .addClass("closedMobileFilter");
};

const scrollToTop = (isMobile) => {
  if (!isMobile && $(".featured-sales").length > 0) {
    if ($(".featured-sales").css("display") === "block") {
      const targetScrollTop = $(".sticky-wrapper").offset().top - 50;
      window.scrollTo(0, targetScrollTop);
    }
  } else {
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }
};

const removeFeaturedSales = () => {
  $(".featured-sales").hide();
};

const adjustDropdownWidth = () => {
  const titleWidth = $(".selectedNonColorMultiSelectTitle").css("width");
  if (titleWidth === 0) {
    return;
  }
  $(".selectedNonColorMultiSelectDropdown").css("min-width", titleWidth);
};

const view = {
  fadeFilter,
  showFilter,
  fadeResult,
  showResult,
  loadCategory,
  showCategory,
  loadResultsData,
  toggleMobileFilter,
  turnOnDesktopFilter,
  turnOffDesktopFilter,
  removeFeaturedSales,
  adjustDropdownWidth,
  scrollToTop,
};

export default view;
